'use client'

import { useCallback, useState } from 'react'
import { useParams, useRouter } from 'next/navigation'

import { CreateProjectDialog } from '@common/core/components/CreateProjectDialog'

import { CreateWorkspaceForm } from '../forms'

import styles from './CreateWorkspaceView.module.scss'

export function CreateWorkspaceView() {
  const router = useRouter()
  const params = useParams()
  const locale = params.locale as string

  const [isCreateProjectDialogOpen, setIsCreateProjectDialogOpen] = useState(false)

  const handleWorkspaceCreated = useCallback(() => {
    setIsCreateProjectDialogOpen(true)
  }, [])

  const handleDialogOpenChange = useCallback((open: boolean) => {
    setIsCreateProjectDialogOpen(open)
  }, [])

  const handleAfterClose = useCallback(() => {
    router.push(`/${locale}/dashboard`)
  }, [router, locale])

  return (
    <div className={styles.workspaceLayout}>
      <section className={styles.workspaceForm}>
        <CreateWorkspaceForm onWorkspaceCreated={handleWorkspaceCreated} />
      </section>
      <aside className={styles.workspaceVisual}></aside>

      <CreateProjectDialog
        open={isCreateProjectDialogOpen}
        onOpenChange={handleDialogOpenChange}
        onAfterClose={handleAfterClose}
      />
    </div>
  )
}
